"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateGtmConsent = void 0;
const consent_1 = require("../consent");
const updateGtmConsent = (consent) => {
    (0, consent_1.storeConsentToCookie)(consent);
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== "function") {
        window.gtag = function () {
            // eslint-disable-next-line prefer-rest-params
            window.dataLayer.push(arguments);
        };
    }
    window.gtag("consent", "update", {
        analytics_storage: consent.analytics_storage ? "granted" : "denied",
        ad_storage: consent.ad_storage ? "granted" : "denied",
        personalization_storage: consent.personalization_storage ? "granted" : "denied",
    });
};
exports.updateGtmConsent = updateGtmConsent;
